import { Component, ViewChild, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'adminapp-save-site-type',
  templateUrl: './save-site-type.component.html',
  styleUrls: ['./save-site-type.component.scss']
})
export class SaveSiteTypeComponent {


  @ViewChild('confirmSiteTypeModal') saveSiteTypeModal;

  @Output()
  siteTypeSelectedEmitter = new EventEmitter<any>();

  constructor() { }

  openSaveDialog() {
    this.openDialog();
  }

  handleConfirmClicked() {
    this.siteTypeSelectedEmitter.emit();
  }

  openDialog() {
    this.saveSiteTypeModal.nativeElement.open();
  }

}
